import { SyncEventType } from '../../enums/syncEventType';
import { PersistenceEvent } from './persistenceEvent';

export class EventSprintCreated implements PersistenceEvent {

  public readonly type = SyncEventType.SPRINT_CREATED;
  // The real sprintId from the issuetracking-system
  public sprintId: number;
  // The temporary sprintId we used to identify the new sprint before it was persisted to the issuetracking-system
  public temporarySprintId: number;

  constructor(sprintId: number, temporarySprintId: number) {
    this.sprintId = sprintId;
    this.temporarySprintId = temporarySprintId;
  }

  getPayload(): object {
    const payload = {
      'sprintId': this.sprintId,
      'temporarySprintId': this.temporarySprintId
    };
    return payload;
  }

  static fromPayload(payload: any): EventSprintCreated {
    return new EventSprintCreated(
      payload['sprintId'],
      payload['temporarySprintId']
    );
  }

}

